import React from 'react';
import { List } from 'antd-mobile';
import Detail from './detail/Detail';
import SectionLive from './lives/SectionLive';
import PropTypes from 'prop-types';

const Card = props => {
    return (
        <div>
            <List renderHeader={() => <div className='common' style={{textAlign: 'left', fontWeight: '700'}}>{props.formattedDate}</div>}>
                <Detail {...props} />
            </List>
            <SectionLive {...props} />
        </div>
    )
}

Card.propTypes = {
    formattedDate: PropTypes.string.isRequired
}

export default Card;